<template>
    <div class="bg-white rounded">
        <h3 class="font-weight-bold px-3 f-20 pt-4 text-left mb-3 text-black">{{ $t('general.title') }}</h3>
        <b-form class="pb-3 px-3">
            <b-row class="mb-4">
                <b-col lg="7" md="12" sm="12">
                    <div class="upload-btn-wrapper mt-2 text-black text-black" :class="{ 'h-auto': companyLogoUrl }">
                        <b-img :src="companyLogoUrl
                            ? companyLogoUrl
                            : require('@/assets/upload_logo.svg')
                            " :class="{
        img_custom: companyLogoUrl,
    }"></b-img>
                        <button v-if="!companyLogoUrl" class="foo">
                            {{ $t('general.dropLogo') }}
                        </button>
                        <input ref="imageFile" type="file" name="imageFile" id="logoUpload" v-on:change="handleImageUpload"
                            :disabled="!allowUpdateSettings" accept="image/*" />
                    </div>
                    <div class="buttons text-left" v-if="allowUpdateSettings">
                        <b-button class="mt-2 cancel" v-if="companyLogoUrl" @click="resetImage">{{ $t('general.reset') }}</b-button>
                        <b-button @click="updateCompanyData" v-if="companyLogo" class="ml-3 mt-2 save"
                            variant="primary">{{ $t('general.save') }}</b-button>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col lg="7" md="12" sm="12">
                    <hr class="my-0" />
                </b-col>
            </b-row>
            <b-row class="mt-3">
                <b-col lg="7" md="12" sm="12">
                    <b-row class="text-left mb-3">
                        <b-col sm="12" class="my-auto">
                            <label>{{ $t('general.companyNameLabel') }}</label>
                        </b-col>
                        <b-col sm="12">
                            <b-form-input v-model="company[0].name" disabled
                                :placeholder="$t('general.companyNamePlaceholder')"></b-form-input>
                            <p v-if="errors && errors.name" class="field-error mb-lg-3">
                                {{ errors.name[0] }}
                            </p>
                        </b-col>
                    </b-row>
                    <b-row class="text-left mb-3">
                        <b-col sm="12" class="my-auto">
                            <label>{{ $t('general.addressLabel') }}</label>
                        </b-col>
                        <b-col sm="12">
                            <b-form-input v-model="company[0].address" :disabled="!allowUpdateSettings"
                                :placeholder="$t('general.addressPlaceholder')"></b-form-input>
                        </b-col>
                    </b-row>
                    <b-row class="text-left mb-3">
                        <b-col sm="12" class="my-auto">
                            <label>{{ $t('general.cityLabel') }}</label>
                        </b-col>
                        <b-col sm="12">
                            <b-form-input v-model="company[0].city" :disabled="!allowUpdateSettings"
                                :placeholder="$t('general.cityPlaceholder')"></b-form-input>
                        </b-col>
                    </b-row>
                    <b-row class="text-left mb-3">
                        <b-col sm="12" class="my-auto">
                            <label>{{ $t('general.stateLabel') }}</label>
                        </b-col>
                        <b-col sm="12">
                            <v-select class="bg_white w-100" :disabled="!allowUpdateSettings" v-model="companyStateId"
                                :options="states" item-value="id" item-text="label" :reduce="(option) => option.id" />
                        </b-col>
                    </b-row>

                    <b-row class="text-left mb-3">
                        <b-col sm="12" class="my-auto">
                            <label>{{ $t('general.postalCodeLabel') }}</label>
                        </b-col>
                        <b-col sm="12">
                            <b-form-input v-model="company[0].zipcode" :disabled="!allowUpdateSettings"
                                :placeholder="$t('general.postalCodePlaceholder')"></b-form-input>
                        </b-col>
                    </b-row>
                    <b-row class="text-left mb-3">
                        <b-col sm="12" class="my-auto">
                            <label>{{ $t('general.phoneNumberLabel') }}</label>
                        </b-col>
                        <b-col sm="12">
                            <b-input-group size="lg" class="w-100" prepend="+1">
                                <b-form-input class="f-14" v-mask="phoneMask" v-model="companyPhoneNumber"
                                    :disabled="!allowUpdateSettings"></b-form-input>
                            </b-input-group>
                            <p v-if="errors && errors.phone" class="field-error mb-lg-3">
                                {{ errors.phone[0] }}
                            </p>
                        </b-col>
                    </b-row>
                    <!-- <b-row class="text-left mb-3">
                        <b-col sm="12" class="my-auto">
                            <label>{{ $t('general.emailLabel') }}</label>
                        </b-col>
                        <b-col sm="12">
                            <b-form-input v-model="company[0].email" :disabled="$store.state.user.company[0].phone.role !== 'Admin' &&
                      $store.state.user.company[0].phone.role !== 'Operations'" :placeholder="$t('general.emailPlaceholder')"></b-form-input>
                            <b-icon class="position-absolute" icon="envelope"></b-icon>
                            <p v-if="errors && errors.email" class="field-error mb-lg-3">
                                {{ errors.email[0] }}
                            </p>
                        </b-col>
                    </b-row> -->
                    <div class="buttons text-left">
                        <b-button v-if="allowUpdateSettings && hasChanged" @click="updateCompanyData" btn class="mt-3 save"
                            variant="primary">{{ $t('general.save') }}</b-button>
                    </div>
                </b-col>
            </b-row>
        </b-form>
    </div>
</template>
<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { mapActions, mapGetters } from "vuex";
import { checkValueExists, checkPhoneFormat } from "../../services/helper";
export default {
    name: "General",
    components: { vSelect },
    data() {
        return {
            checkValueExists,
            checkPhoneFormat,
            companyLogo: null,
            companyLogoUrl: null,
            defaultData: {},
            qrCodeUrl: "",
            bindProps: {
                mode: "international",
                autoFormat: true,
                preferredCountries: ["US", "CA", "MX"],
                inputOptions: {
                    placeholder: "Enter a phone no.",
                    maxlength: 30,
                },
                dropdownOptions: {
                    showSearchBox: true,
                    showDialCodeInList: true,
                    showFlags: true,
                    showDialCodeInSelection: true,
                    width: "300px",
                },
            },
            states: [],
            countries: [],
            errors: {
                date: null,
                type: null,
                document: null,
                description: null,
                phone: null,
            }
        }
    },
    methods: {
        ...mapActions(["updateCompany", 'setNotification', "getAllCountries", "setLoader"]),
        handleImageUpload() {
            const file = this.$refs.imageFile.files[0];
            if (!file) return;

            const extension = file.type.split("/").pop();

            const renamedFile = new File(
                [file],
                `${this.company[0].name.replace(/\s+/g, "_")}_${new Date().getTime()}.${extension}`,
                { type: file.type }
            );

            this.companyLogo = renamedFile;
            this.companyLogoUrl = URL.createObjectURL(renamedFile);
        },

        resetImage() {
            this.companyLogo = null
            this.companyLogoUrl = null
            this.$refs.imageFile.value = null
            this.updateCompanyData(true)
        },
        payloadToFormData(payload) {
            let formData = new FormData();
            for (let [key, value] of Object.entries(payload)) {
                if (key === "logo") {
                    if (this.companyLogo) {
                        formData.append(key, this.companyLogo, this.companyLogo.name);
                    }
                    else if (!this.companyLogoUrl) {
                        formData.append("logo", "")
                    }
                }
                else if (key !== 'logo' && value) {
                    formData.append(key, value);
                }

            }
            return formData;
        },
        async updateCompanyData(removeImage = false) {
            try {
                this.setLoader(true)
                this.errors = {
                    date: null,
                    type: null,
                    document: null,
                    description: null,
                    phone: null,
                };
                if (this.company[0].phone) {
                    if (!this.checkPhoneFormat(this.companyPhoneNumber)) {
                        throw {
                            phone: [this.$t('general.wrongFormat')],
                        };
                    }
                }

                const validationFields = ["name"];
                let errors = {};
                validationFields.forEach((e) => {
                    if (!this.company[0][e]) {
                        errors[e] = [this.$t('general.fieldRequired')];
                    }
                });
                if (Object.keys(errors).length > 0) {
                    throw errors;
                }
                let companyData = {
                    ...this.company[0],
                    state: this.company[0].state.id,
                    company_id: this.userCompany,
                    phone: this.company[0].phone ? !this.company[0].phone.includes("+1") ? "+1 " + this.company[0].phone : this.company[0].phone : '',
                    ...removeImage ? { logo: "" } : {},
                    motive_access_token_expiry: this.company[0].motive_access_token_expiry ? this.company[0].motive_access_token_expiry : ''
                };
                const formData = this.payloadToFormData(companyData);
                const updatedCompany = await this.updateCompany({
                    id: `${this.userCompany}`,
                    payload: formData,
                });
                if (updatedCompany) {
                    this.company[0] = updatedCompany;
                    await this.setNotification({
                        msg: this.$t('general.updated', { name: this.company[0].name }),
                        type: "success",
                        color: "green",
                    });
                    this.companyLogo = null
                }
                this.setLoader(false)
            } catch (error) {
                this.setLoader(false)
                if (typeof error === "object") {
                    this.errors = error;
                    // eslint-disable-next-line no-ex-assign
                }
            }
        },
        async getCountries() {
            await this.getAllCountries();
            this.countries = this.allCountries.map((item) => ({
                id: item.id,
                label: item.name,
            }));
            this.getStates(this.countries[0]);
        },
        getStates(selectedOption) {
            this.states = this.allCountries
                .filter((country) => country.id === selectedOption.id)[0]
                .state.map((item) => ({
                    id: item.id,
                    label: item.name,
                }));
            if (this.states.length === 0) {
                this.company[0].state.id = null;
            }
        },
    },
    computed: {
        ...mapGetters(['company', "allCountries", "userCompany", 'rolePermissions']),
        allowUpdateSettings() {
            return this.rolePermissions && this.rolePermissions['Company Settings / Integrations'] && this.rolePermissions['Company Settings / Integrations'][0].allow
        },
        companyStateId: {
            get() {
                return this.company[0].state && this.company[0].state.id
                    ? this.company[0].state.id
                    : this.company[0].state;
            },
            set(value) {
                if (!this.company[0].state || typeof this.company[0].state !== 'object') {
                    this.company[0].state = {};
                }
                this.company[0].state.id = value;
            }
        },
        hasChanged() {
            return Object.keys(this.company[0]).filter(field => {
                if (field !== 'docs' && field !== 'updated_at' && field !== 'motive_access_token' && field !== 'motive_access_token_expiry') {
                    if (typeof this.company[0][field] === 'object') return JSON.stringify(this.company[0][field]) !== JSON.stringify(this.defaultData[field])
                    else return this.checkValueExists(this.company[0][field]) != this.checkValueExists(this.defaultData[field])
                } return false
            }).length > 0
        },
        companyPhoneNumber: {
            get: function () {
                return this.company[0].phone ? this.company[0].phone.startsWith("+1") ? this.company[0].phone.slice(2).trim() : this.company[0].phone : ''
            },
            set: function (newValue) {
                this.company[0].phone = newValue
            }
        },
        phoneMask() {
            return this.companyPhoneNumber?.length > 0
                ? [
                    /\d/, /\d/, /\d/, " ",
                    /\d/, /\d/, /\d/, " ",
                    /\d/, /\d/, /\d/, /\d/
                ]
                : false; // Allows empty input
        },
    },
    watch: {
        company: {
            async handler() {
                this.companyLogoUrl = this.company[0].logo
                this.defaultData = JSON.parse(JSON.stringify(this.company[0]))
                await this.getCountries();
                if (!this.company[0].state) {
                    this.company[0].state = {
                        id: this.states[0].id,
                        name: null,
                        country: 1,
                    };
                }
            },
            immediate: true,
        }
    },

}
</script>
<style>